<div class="track" [class.track--square]="!rounded()" [style.height.px]="height()">
  <div class="pulse"></div>
</div>
